import Dexie, { type EntityTable } from 'dexie';

export interface FileItem {
  id: string;
  title: string;
  createdAt: number | string;
  format: string;
  status: 'PENDING' | 'DONE' | 'ERROR' | 'CANCELLED';
}

export const db = new Dexie('DownloadPanel') as Dexie & {
  downloadList: EntityTable<
    FileItem,
    'id' // primary key "id" (for the typings only)
  >;
};

// Schema declaration:
db.version(1).stores({
  downloadList: 'id, title, createdAt, format, status', // primary key "id" (for the runtime!)
});
